import { Component, ViewChild } from "@angular/core";
import { DxDataGridComponent } from "devextreme-angular";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from 'file-saver';
import { NotificationService } from "src/app/common/component/notification/notification.service";
import { GlobalASUForecastReportService } from "./global-asu-forecast-report.service";

@Component({
    selector: 'GlobalASUForecastReport',
    templateUrl:'./global-asu-forecast-report.component.html',
    styleUrls:['./global-asu-forecast-report.component.scss']
})

export class GlobalASUForecastReportComponent {

    isLoadPanelVisible: boolean = false;
    globalASUForecastReportData: any;
    readonly allowedPageSizes = [50, 100, 200];
    @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;

    constructor(private notificationService: NotificationService, private globalASUForecastReportService : GlobalASUForecastReportService) {        
     this.getGlobalASUForecastReport();   
    }

    getGlobalASUForecastReport(){
        this.isLoadPanelVisible = true;
        this.globalASUForecastReportService.getGlobalASUForecastReport().subscribe({
            next: globalASUForecastReportData => {
                this.globalASUForecastReportData = globalASUForecastReportData;
                this.isLoadPanelVisible = false;
            }, error: (error: any) => {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("error", "Error while fetching GlobalASUForecastReport data", error);
            }
        });
    }

    resetFilters() {
        this.dataGrid.instance.clearFilter();
        this.dataGrid.instance.clearSorting();
    }

    exportExcel(e) {        
        this.dataGrid.instance.columnOption('siteId', 'visible', true);
        this.dataGrid.instance.columnOption('productionFacilityId', 'visible', true);
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');
        exportDataGrid({
            component: this.dataGrid.instance,
            worksheet: worksheet
        }).then(function () {
            workbook.xlsx.writeBuffer()
                .then(function (buffer: BlobPart) {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'GlobalASUForecastReportData.xlsx');
                });
        }).then(()=>{            
        this.dataGrid.instance.columnOption('siteId', 'visible', false);
        this.dataGrid.instance.columnOption('productionFacilityId', 'visible', false);        
        });
        e.cancel = true;
    }
}